import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Card = styled.div`
  background-color: ${colors.white};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 5px;
  padding: 20px;
  cursor: pointer;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`
export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 41px;
  flex-direction: row;
  align-items: center;
  padding: 14px 30px;
  justify-content: space-between;
  background-color: ${colors.dashboard};
  z-index: 97;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 20px 20px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`
